import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { basicPressReleases } from 'store/entities/professionalReport/selectors/basicDataSelectors';
import PressReleasesTable from 'components/reusable/report/tables/PressReleasesTable';

import { Row, Card } from 'antd';
import { ReactComponent as PressReleasesIcon } from 'assets/img/icons/cardIcons/pressReleases.svg';
import CompanyDataCard, { CompanyDataRow } from '../../../components/reusable/CompanyDataCard';
import BriefDisclaimer from '../../../components/reusable/BriefDisclaimer';

const PressReleases = ({ briefPdf }) => {
  const [customReport, setCustomReport] = useState(null);
  const { t } = useTranslation();
  const { pressReleases, pressReleasesVersloZinios } = useSelector(basicPressReleases);

  const { customPdfValues } = useSelector(state => state.professionalReport);

  useEffect(() => {
    if (customPdfValues && 'PressRelease' in customPdfValues) {
      setCustomReport(customPdfValues['PressRelease']);
    }
  }, [customPdfValues]);

  const filteredOutReleseas = [
    ...pressReleases.filter(release => release.source && !release.source.includes('Vz.lt')),
    ...pressReleasesVersloZinios,
  ].sort((a, b) => new Date(b.publishDate) - new Date(a.publishDate));

  return (
    <CompanyDataCard
      icon={<PressReleasesIcon />}
      title={t('professionalReport.basicData.press.pressReleases.title')}
      disclaimer={!customPdfValues && briefPdf && t(`professionalReport.basicData.press.pressReleases.briefDisclaimer`)}
    >
      {customPdfValues && !customReport ? (
        <>
          <CompanyDataRow type={t('professionalReport.basicData.press.count')} value={filteredOutReleseas?.length} />
          <Card className="card-transparent space-vertical-sm">
            {t('professionalReport.basicData.press.customDisclaimer')}
          </Card>
        </>
      ) : (
        <>
          {filteredOutReleseas?.length > 0 ? (
            <PressReleasesTable pressReleases={briefPdf ? filteredOutReleseas.slice(0, 20) : filteredOutReleseas} />
          ) : (
            <Card className="card-transparent space-vertical-sm">
              {t('professionalReport.basicData.press.noPressReleases')}
            </Card>
          )}
          {briefPdf && filteredOutReleseas?.length > 20 && <BriefDisclaimer type={'press'} />}
        </>
      )}
    </CompanyDataCard>
  );
};

export default PressReleases;
